import React from 'react'
import { useTheme } from '@mui/material'
import { PieChartComponent } from '../../../common/components/PieChartComponent/PieChartComponent'
import { useStyles } from './TrafficSources.styles'
import { CustomLegends } from '../../FlyoutOverview/CustomLegends/CustomLegends'
import { PieCustomTooltip } from '../PieCustomTooltip/PieCustomTooltip'
import { numberFormat } from '@labrav/common'
import { useSelector } from '../../../store'
import { MetricsData } from '../../../modules/storefrontMetrics/reducer'

export const TrafficSources = () => {
  const { classes } = useStyles()
  const theme = useTheme()
  const { trafficSource } = useSelector<MetricsData>(
    state => state.storefrontMetricsData
  )
  const getColorForProduct = (index: number) => {
    if (index === 0) return theme.palette.awsGraph.main
    if (index === 1) return theme.palette.gcpGraph.main
    if (index === 2) return theme.palette.otherGraph.main
    return theme.palette.microsoftGraph.main
  }

  const datapie = trafficSource.top3 ?? []
  const otherProducts = trafficSource.otherTrafficSource ?? []
  const otherProductsTotalValue = otherProducts.reduce(
    (sum, item) => sum + (item.count ?? 0),
    0
  )
  const otherProductsTotalPercentage = parseFloat(
    otherProducts
      .reduce((sum, item) => sum + (item.percentage ?? 0), 0)
      .toFixed(2)
  )

  const topProducts = [
    ...datapie
      .filter(item => item.count !== 0)
      .map((item, index) => ({
        id: item.ref as string,
        label: item.ref as string,
        value: item.count as number,
        color: getColorForProduct(index),
      })),
    ...(otherProductsTotalValue !== 0
      ? [
          {
            id: 'Other',
            label: 'Others',
            value: otherProductsTotalValue as number,
            color: getColorForProduct(3),
          },
        ]
      : []),
  ]

  const percentageData: Record<string, number> = {
    ...datapie.reduce(
      (acc, item) => ({
        ...acc,
        [item.ref as any]: parseFloat(item.percentage?.toFixed(2) || '0'),
      }),
      {} as Record<string, number>
    ),
    Other: otherProductsTotalPercentage,
  }

  const transformedOtherProducts = otherProducts
    .filter(item => item.count !== 0)
    .map(item => ({
      id: item.ref as string,
      label: item.ref as string,
      value: item.count as number,
      percentage: otherProductsTotalPercentage,
      color: theme.palette.awsGraph,
    }))

  const customLegendsData = [
    ...datapie
      .filter(item => item.count !== 0)
      .map((item, index) => ({
        label: item.ref as string,
        legendColor: getColorForProduct(index),
        legendSize: 'medium' as const,
        value: `${numberFormat(item.count as number)}`,
        isKeyValue: true,
      })),
    ...(otherProductsTotalValue !== 0
      ? [
          {
            label: 'Other Products',
            legendColor: theme.palette.microsoftGraph.main,
            legendSize: 'medium' as const,
            value: `${numberFormat(otherProductsTotalValue)}`,
            isKeyValue: true,
          },
        ]
      : []),
  ]

  return (
    <>
      <div
        className={classes.responsivePieWrapper}
        data-testid={'traffic-sources-chart'}
      >
        <div className={classes.leftContainer}>
          <PieChartComponent
            data={topProducts}
            height="184px"
            width="176px"
            colors={[
              theme.palette.awsGraph.main,
              theme.palette.gcpGraph.main,
              theme.palette.otherGraph.main,
              theme.palette.microsoftGraph.main,
            ]}
            tooltipContent={point => (
              <PieCustomTooltip
                percentage={percentageData[point?.datum?.data.id]}
                otherProducts={transformedOtherProducts}
                point={point}
              />
            )}
          />
        </div>
        <div className={classes.rightContainer}>
          <CustomLegends flexDirection="column" legends={customLegendsData} />
        </div>
      </div>
    </>
  )
}
